module.exports = __webpack_public_path__ + "img/logo.922e1ff8.svg";